<template>
  <b-overlay variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="sm" :show="isLoading">
    <validation-observer ref="individualOrganizationSaveModalRef">
      <div id="individual_organization_evaluate_page" v-if="Object.keys(checkIndividualOrganizationEvaluate).length && checkIndividualOrganizationEvaluate.timeOfOccurrence === 1 && checkIndividualOrganizationEvaluate.evaluated === 0 && individualOrganizationEvaluate">
        <div class="text-center set-of-criteria-object">{{ checkIndividualOrganizationEvaluate.setOfCriteriaObjectName ? checkIndividualOrganizationEvaluate.setOfCriteriaObjectName : '' }}<span> ({{
          isCreated ? 'Tạo mới' : 'Cập nhật' }})</span></div>
        <div class="">
          <b-row class="mx-3 my-2" v-if="individualOrganizationEvaluate.objectGroupEvaluateCriterias">
            <div class="">
              <feather-icon icon="EditIcon" size="22" />
              Thực hiện trả lời các câu hỏi dưới đây:
            </div>
          </b-row>
          <div v-if="individualOrganizationEvaluate.objectGroupEvaluateCriterias">
            <div v-for="(item, index) in individualOrganizationEvaluate.objectGroupEvaluateCriterias" :key="index"
              class="mx-3">
              <div class="mx-5">
                <b-row v-if="item.criteriaType === CRITERIA_TYPES[0].value">
                  <b-col cols="12" md="12">
                    <b-form-group :label-for="item.name">
                      <template v-slot:label>
                        {{ (index + 1) + ". " + item.name }} <span class="text-danger">*</span>
                      </template>
                      <vue-slider v-model="item.point" direction="ltr" :max="item.maxPoint" :min="1" style="width: 50%;"
                        class="mx-1 my-2" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  v-if="item.criteriaType === CRITERIA_TYPES[1].value && item.multipleSelect != MULTIPLE_CRITERIA_OPTION_TYPES[1].value">
                  <b-col cols="12" md="12">
                    <b-form-group :label-for="item.name">
                      <template v-slot:label>
                        {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                      </template>
                      <validation-provider #default="{ errors }" name="Câu hỏi này"
                        :rules="(item.required ? 'required' : '')">
                        <b-form-radio-group :id="'skin-radio-group_' + index" v-model="item.evaluationCriteriaOptionId[0]"
                          :name="'skin_' + index" :options="item.evaluationCriteriaOptions"
                          class="custom-control-primary pl-2" :state="getElementState(errors)"
                          @input="checkDisabledSubmitButton" />
                        <small class="text-danger mx-1">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row
                  v-if="item.criteriaType === CRITERIA_TYPES[1].value && item.multipleSelect === MULTIPLE_CRITERIA_OPTION_TYPES[1].value">
                  <b-col cols="12" md="12">
                    <b-form-group :label-for="item.name">
                      <template v-slot:label>
                        {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                      </template>
                      <validation-provider #default="{ errors }" name="Câu hỏi này"
                        :rules="(item.required ? 'required' : '')">
                        <b-form-checkbox-group :id="'skin2-radio-group_' + index"
                          v-model="item.evaluationCriteriaOptionId" class="custom-control-primary pl-2"
                          :options="item.evaluationCriteriaOptions" :state="getElementState(errors)"
                          @input="checkDisabledSubmitButton" />
                        <small class="text-danger mx-1">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="item.criteriaType === CRITERIA_TYPES[2].value">
                  <b-col cols="12" md="12">
                    <b-form-group :label-for="item.name">
                      <template v-slot:label>
                        {{ (index + 1) + '. ' + item.name }} <span class="text-danger" v-if="item.required">*</span>
                      </template>
                      <validation-provider #default="{ errors }" name="Câu hỏi này"
                        :rules="(item.required ? 'required' : '')">
                        <b-form-textarea :id="'question_' + index" placeholder="Nhập câu trả lời" rows="3"
                          v-model="item.content" :state="getElementState(errors)" class="mx-1 mt-2"
                          @input="checkDisabledSubmitButton" />
                        <small class="text-danger mx-1">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              
            </div>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="12" md="12">
                <div class="text-center my-2"><b>Không có câu hỏi khảo sát/đánh giá nào!</b></div>
              </b-col>
            </b-row>
          </div>
          <template v-if="individualOrganizationEvaluate.objectGroupEvaluateCriterias">
            <div class="w-100 d-flex justify-content-end my-1" id="individual_organization_evaluate_bottom_page">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-1"
                :disabled="isDisabledSubmitButton" @click="onSave()">
                <span class="text-right">
                  <feather-icon icon="CheckIcon" /> Gửi đánh giá
                </span>
              </b-button>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-secondary"
                @click="cancelEvaluate">
                <span class="text-right"> <feather-icon icon="XIcon" /> Hủy </span>
              </b-button>
            </div>
          </template>
        </div>
      </div>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BOverlay,
  BRow,
  BFormDatepicker,
  BFormTextarea,
  BCardHeader,
  BCardTitle,
  BFormRadioGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import * as events from 'events'
import VueSlider from 'vue-slider-component'
import { CRITERIA_TYPES, MULTIPLE_CRITERIA_OPTION_TYPES } from '@/const/type'
import api from './api'


export default {
  name: 'SetOfCriteriaSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    vSelect,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    VueSlider,
    BCardHeader,
    BCardTitle,
    BFormRadioGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    setOfCriteriaObjectId: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      required,
      isLoading: false,
      isDisabledSubmitButton: false,
      CRITERIA_TYPES,
      MULTIPLE_CRITERIA_OPTION_TYPES,
      checkIndividualOrganizationEvaluate: null,
      individualOrganizationEvaluate: {},
    }
  },
  async created() {
    this.isLoading = true
    try {
      await this.showPopup()
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  computed: {
    events() {
      return events
    },
    isCreated() {
      return this.individualOrganizationEvaluate.id === null
    },
  },
  methods: {
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    checkShowButtonSubmitCreated() {
      this.isLoading = true
      for (let i = 0; i < this.individualOrganizationEvaluate.objectGroupEvaluateCriterias?.length; i++) {
        if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[0].value && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].point === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].required === 1 && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId.length === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[2].value && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].required === 1 && (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].content === '' || this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].content === null)) {
          this.isDisabledSubmitButton = true
          break;
        }
      }

      //Check show point for each criteria option
      if (this.checkIndividualOrganizationEvaluate && this.checkIndividualOrganizationEvaluate.setOfEvaluateLevelId) {
        for (let i = 0; i < this.individualOrganizationEvaluate.objectGroupEvaluateCriterias.length; i++) {
          if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value) {
            this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptions.forEach(option => {
              option.text = option.text + " (" + option.point + " điểm)"
            })
          }
        }
      }

      this.isLoading = false
    },
    async onSave() {
      const valid = this.$refs
        .individualOrganizationSaveModalRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await api.createIndividualOrganizationEvaluate(this.individualOrganizationEvaluate)
            : await api.updateIndividualOrganizationEvaluate(this.individualOrganizationEvaluate)
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
    async onGetIndividualOrganizationEvaluate() {
      this.isLoading = true
      try {
        const email = document.getElementById('customEmailInput').value;
        this.checkIndividualOrganizationEvaluate = await api.getIndividualOrganizationEvaluate({ setOfCriteriaObjectId: Number(this.setOfCriteriaObjectId), email: email })
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    showToast(title, icon, variant, autoHideDelay = 1000) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          autoHideDelay,
        },
      })
    },
    checkDisabledSubmitButton() {
      this.isDisabledSubmitButton = false
      for (let i = 0; i < this.individualOrganizationEvaluate.objectGroupEvaluateCriterias.length; i++) {
        if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[0].value && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].point === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].required === 1 && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId.length === 0) {
          this.isDisabledSubmitButton = true
          break;
        }
        if (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[2].value && this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].required === 1 && (this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].content === '' || this.individualOrganizationEvaluate.objectGroupEvaluateCriterias[i].content === null)) {
          this.isDisabledSubmitButton = true
          break;
        }
      }
    },
    async showPopup() {
      this.$swal
        .fire({
          title: 'Vui lòng nhập email cá nhân hoặc tổ chức!',
          text: 'Vui lòng nhập email cá nhân hoặc tổ chức!',
          html: '<input id="customEmailInput" class="form-control" type="email" placeholder="Nhập email ...">', // HTML tùy chỉnh
          confirmButtonText: '<i class="fa-solid fa-check"></i> Lấy đánh giá',
          cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          allowEscapeKey: false,
          allowOutsideClick: false,
          buttonsStyling: false,
          showCancelButton: true,
          focusConfirm: false,
          didOpen: () => {
            const title = document.querySelector('.swal2-title');
            if (title) {
              title.style.fontSize = '1.1rem';  // Thiết lập font-size trực tiếp
            }
          },
          preConfirm: async () => {
            const email = document.getElementById('customEmailInput').value;
            if (!email) {
              return this.$swal.showValidationMessage('Vui lòng nhập email!');
            }

            const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailPattern.test(email)) {
              return this.$swal.showValidationMessage('Vui lòng nhập email hợp lệ!');
            }

            await this.onGetIndividualOrganizationEvaluate()
            if (Object.keys(this.checkIndividualOrganizationEvaluate).length === 0) {
              return this.$swal.showValidationMessage('Không tìm thấy đợt khảo sát đánh giá');
            } else if (Object.keys(this.checkIndividualOrganizationEvaluate).length && this.checkIndividualOrganizationEvaluate.evaluated === 1) {
              return this.$swal.showValidationMessage('Bạn đã thực hiện đợt khảo sát/đánh giá này trước đó và không thể cập nhật!');
            } else if (Object.keys(this.checkIndividualOrganizationEvaluate).length && this.checkIndividualOrganizationEvaluate.timeOfOccurrence === 0) {
              return this.$swal.showValidationMessage('Đợt khảo sát đánh giá diễn ra từ ngày ' + this.checkIndividualOrganizationEvaluate.startDate + ' đến hết ngày ' + this.checkIndividualOrganizationEvaluate.endDate);
            } else {
              this.individualOrganizationEvaluate = await api.getDataEvaluateForIndividualOrganization({ individualOrganizationId: this.checkIndividualOrganizationEvaluate.individualOrganizationId, setOfCriteriaObjectId: this.checkIndividualOrganizationEvaluate.setOfCriteriaObjectId, evaluateObjectGroupId: this.checkIndividualOrganizationEvaluate.evaluateObjectGroupId })
              await this.checkShowButtonSubmitCreated()
            }
          },
        })
        .then(result => {
          if (result.dismiss === 'cancel') {
            this.cancelEvaluate();
          }
        });
    },
    cancelEvaluate() {
      this.$router.push({ path: '/' })
    },
  },
  beforeDestroy() {
    // Xóa sự kiện 'beforeunload' khi component bị hủy
    this.individualOrganizationEvaluate = {}
    this.checkIndividualOrganizationEvaluate = null
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .set-of-criteria-object {
    font-family: "Montserrat", Helvetica, Arial, serif;
    font-weight: 700;
    font-size: 1.4rem;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    color: #333;
    line-height: 1.5;
  }

  #individual_organization_evaluate_page {
    font-family: "Montserrat", Helvetica, Arial, serif;
    font-weight: 700;
    font-size: 1.2rem;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    color: #333;
    line-height: 1.5;
  }
  label {
    font-family: "Montserrat", Helvetica, Arial, serif;
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 0.5px;
    text-transform: capitalize;
    color: #333;
    line-height: 1.5;
  }
}

#evaluateCreditClassSaveModal .vue-slider-handle-end {
  display: none;
  pointer-events: none;
}


#customEmailInput {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}

#customEmailInput:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.25);
}

#individual_organization_evaluate_page {
    margin-top: 40px;
    margin-left: 200px;
    margin-right: 200px;
  }
#individual_organization_evaluate_bottom_page {
    padding-left: 100px;
    padding-right: 80px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-slider.scss';

/* CSS để ẩn swal2-validation-message */
#swal2-validation-message {
  font-size: 1rem;
  margin-top: 1rem;
}
</style>
